import * as React from "react";
import { NavLink } from "react-router-dom";
import { Image } from "semantic-ui-react";
import styles from "./SidemenuLink.module.scss";

export type SidemenuLinkProps = {
  handleOnClick?: () => void;
  name: string;
  to: string;
  imgSrc: string;
};

const SidemenuLink: React.FC<SidemenuLinkProps> = ({
  handleOnClick,
  name,
  to,
  imgSrc
}): JSX.Element => (
  <NavLink
    id={"navlink-" + name.toLowerCase()}
    onClick={handleOnClick}
    className={`${styles.sidemenuItem} sidemenuItem`}
    key={name}
    to={to}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isActive={(match: any, location: any) => {
      if (!match) {
        return false;
      }
      return location.pathname.includes(match.url);
    }}
    activeClassName={styles.activeLink}
  >
      <Image className={styles.sidemenuIcon} src={imgSrc} />
      <span className={`${styles.sidemenuName} sidemenuName`}>{name}</span>
  </NavLink>
);

export default SidemenuLink;

